import UltMeta, { Meta } from "./UltMeta/index";
/**
 * 阅读量枚举定义
 */

class Type extends UltMeta {
    SAND_INFO = new Meta(1, "砂石资讯");
}

export const TYPE = new Type();
